import { formatLocalDate } from "@/utils/dateFormat";

export function formatItemDate(publishedDate: string | Date) {
  const date = new Date(publishedDate);
  return {
    shortDateStr: formatLocalDate(date, "MMddyyyy"),
    formattedDate: formatLocalDate(date, "MMM d, yyyy"),
    formattedTime: formatLocalDate(date, "h:mm a"),
  };
}

// Compute the date-group boundary for a feed item by comparing it to the item
// before it in the feed sequence. Returning `true` means the item should
// render a date header above it. Comparing against the previous item — rather
// than identifying a "first item per date" by id — guarantees that no two
// adjacent items can both be marked as the first of their date group, even if
// `items` transiently contains the same id twice (which has been observed
// during reactive-query updates immediately after sending a message).
export function isFirstItemOfDateGroup(
  shortDateStr: string,
  previousItemCreatedAt: string | Date | null | undefined,
): boolean {
  if (!previousItemCreatedAt) return true;
  return formatItemDate(previousItemCreatedAt).shortDateStr !== shortDateStr;
}
